import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const HeroSection = ({ onCtaClick }) => {
  return (
    <section className="relative h-[90vh] min-h-[750px] flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat scale-105"
        style={{ backgroundImage: 'url(https://ik.imagekit.io/aeu02xvjgn/34-padua-hills-theatre-claremont-persian-wedding-photography.jpg?updatedAt=1776888200067)' }}
      >
        {/* Deep Olive & Charcoal Overlay for Branding & Legibility */}
        <div className="absolute inset-0 bg-gradient-to-b from-padua-charcoal/70 via-padua-olive/40 to-padua-charcoal/80" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center text-white mt-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2 }}
        >
          <div className="flex items-center justify-center gap-1 mb-8 text-padua-gold">
            {[...Array(5)].map((_, i) => (
              <SafeIcon key={i} name="Star" className="fill-current w-5 h-5 drop-shadow-md" />
            ))}
          </div>
          
          <h1 className="text-4xl md:text-6xl lg:text-8xl font-serif text-padua-ivory mb-8 leading-[1.1] text-balance drop-shadow-2xl">
            Historic Claremont Wedding Venue for Romantic Celebrations
          </h1>
          
          <p className="text-lg md:text-2xl font-light mb-12 max-w-3xl mx-auto leading-relaxed text-padua-ivory/90 text-balance drop-shadow-lg">
            Spanish Revival architecture, romantic terraces, and garden-style photo locations for unforgettable luxury weddings.
          </p>
          
          <button 
            onClick={onCtaClick}
            className="bg-padua-olive hover:bg-padua-sage text-padua-ivory font-medium px-12 py-5 rounded-sm tracking-[0.2em] transition-all duration-300 shadow-2xl transform hover:-translate-y-1 uppercase text-sm border border-padua-gold/30"
          >
            Schedule a Private Tour
          </button>
          
          <div className="mt-16 flex flex-wrap items-center justify-center gap-6 md:gap-10 text-[10px] md:text-xs font-bold tracking-[0.25em] text-padua-ivory/80 uppercase">
            <span className="flex items-center gap-2 bg-padua-charcoal/30 px-5 py-2.5 rounded-full backdrop-blur-md border border-white/10">
              <SafeIcon name="CheckCircle" className="text-padua-gold w-4 h-4" /> 174 Yelp Reviews
            </span>
            <span className="flex items-center gap-2 bg-padua-charcoal/30 px-5 py-2.5 rounded-full backdrop-blur-md border border-white/10">
              <SafeIcon name="Heart" className="text-padua-gold w-4 h-4" /> Family-Owned
            </span>
            <span className="flex items-center gap-2 bg-padua-charcoal/30 px-5 py-2.5 rounded-full backdrop-blur-md border border-white/10">
              <SafeIcon name="MapPin" className="text-padua-gold w-4 h-4" /> Indoor & Outdoor
            </span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;